import { OrderStep } from '@/constants/order/constants';
import { OrderModel } from '@/store/models/Order';

import { OrderSection, orderSections } from '../sections/constants';

/**
 * Dokąd prowadzi zakładka „Socket Details".
 *
 * Nie na sztywno w przymiarkę: dla zamówienia, które jej nie ma w ścieżce (wyłuszczenie
 * w barku — GLA-64; wcześniej też własny laminowany lej), jedno kliknięcie w widoczną zakładkę
 * lądowało na ekranie usuniętym ze ścieżki. „Next" rzucał tam wyjątkiem, „Back" wyrzucał na
 * ekran nowego zamówienia, a „Save draft" DZIAŁAŁ — czyli protetyk mógł dopisać zamówieniu dane
 * leja testowego, którego ta ścieżka nie przewiduje (wskazała recenzja).
 *
 * Moduł celowo BEZ zależności od store'u: `nav/constants.ts` importuje store, przez co nie da
 * się go wczytać w teście jednostkowym.
 */
export function socketDetailsEntryStep(order?: OrderModel | null): OrderStep {
	const steps = orderSections[OrderSection.SocketDetails];
	const path = order ? OrderStep.pathForOrder(order) : null;

	if (!path) {
		return steps[0];
	}

	// Gdy ścieżka MA przymiarkę, zakładka prowadzi tam gdzie dotąd — zmieniamy zachowanie
	// wyłącznie tam, gdzie było zepsute. Inaczej protetyk wracający do danych leja lądowałby
	// na ekranie, który przy wejściu czyści formularz, i musiałby wybierać wszystko od nowa.
	if (path.includes(OrderStep.CheckSocket)) {
		return OrderStep.CheckSocket;
	}

	return steps.find(step => path.includes(step)) ?? steps[0];
}
